var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApproveIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3600pt",
    height: "3600pt",
    viewBox: "0 0 3600 3600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f5692e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m232.26 1800c0-833.77 675.91-1509.7 1509.7-1509.7 344.85 0 662.39 115.48 916.53 309.94 50.934 38.977 123.83 29.281 162.8-21.656 38.973-50.934 29.277-123.82-21.656-162.8-293.24-224.38-660.04-357.75-1057.7-357.75-962.04 0-1741.9 779.89-1741.9 1741.9 0 962.05 779.89 1741.9 1741.9 1741.9 962.05 0 1741.9-779.89 1741.9-1741.9 0-64.137-51.992-116.13-116.13-116.13-64.137 0-116.13 51.992-116.13 116.13 0 833.77-675.91 1509.7-1509.7 1509.7-833.77 0-1509.7-675.9-1509.7-1509.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3566 836.95c45.352-45.352 45.352-118.88 0-164.23-45.348-45.352-118.88-45.352-164.23 0l-1501.8 1501.8c-45.348 45.348-118.88 45.348-164.23 0l-724.55-724.55c-45.352-45.352-118.88-45.352-164.23 0-45.352 45.348-45.352 118.88 0 164.23l724.55 724.55c136.05 136.05 356.63 136.05 492.69 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveIcon2);
export default __webpack_public_path__ + "static/media/approveIcon2.d8bbdea740184206560a72670b345174.svg";
export { ForwardRef as ReactComponent };